import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import api from '../../axios/api';
import * as actionTypes from './actionTypes';
import { fetchPlacesLeafsService } from '../../services/places';
import { fetchEquipmentModelsService } from '../../services/equipmentModes';
import { fetchGroupsServices } from '../../services/groups';
import { fetchAreas } from '../../services/areas';
import { fetchCompaniesService } from '../../services/companies';
import { fetchEquipmentServices, fetchEquipmentsService } from '../../services/equipments'
import { ISite } from '../../models/isite';
import { IEquipmentModel } from '../../models/iequipmentModel';
import { IEquipmentGroup } from '../../models/iequipmentGroup';
import { IArea } from '../../models/iarea';
import { IPlace } from '../../models/iplace';
import { ICompany } from '../../models/icompany';
import { IEquipment } from '../../models/iequipment';
import { ICreateServiceState, IServiceDraft } from '../reducers/createService';
import { IAutocompleteOption } from '../../models/iautocompleteOption';
import { IService } from '../../models/iservice';
import { IQuestion } from '../../models/iquestion';
import { IOldAction } from '../../components/ServiceOldActionsPanel/ServiceOldActionsPanel';
import { fetchQuestions } from './questions';
import { IAction } from '../../models/iaction';
import { IFile } from '../../UI/FileList';
import { ISignature } from '../../containers/Services/CreateService/Checklist/SignatureModal';
import { uploadSignature } from '../../utils/uploadSignature';
import { TEquipmentWithServicesEquipmentService } from '../../models/iequipmentWithServices';
import { i18n } from '../../translate/i18n';
import { ICreateServiceBody, IUpdateServiceDraftBody } from '../../containers/Services/CreateService/Checklist/Checklist';

const CancelToken = axios.CancelToken;
let getServiceFormActions_cancel: any;
let getEquipmentsForCreateService_cancel: any;
let createDraft_cancel: any;

const fetchPlacesStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_PLACES_START
  };
};

const fetchPlacesSuccess = (places: IPlace[] ) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_PLACES_SUCCESS,
    payload: places,
  };
};

const fetchPlacesFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_PLACES_FAIL,
  };
};


export const createServiceFetchPlaces = (sites: ISite[]) => {
  return (dispatch: any) => {
    dispatch(fetchPlacesStart());
    fetchPlacesLeafsService(sites)
      .then((res: any) => {
        dispatch(fetchPlacesSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchPlacesFail());
      });
  };
};

const fetchEquipmentModelsStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_START
  };
};

const fetchEquipmentModelsSuccess = (equipmentModels: IEquipmentModel[] ) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_SUCCESS,
    payload: equipmentModels,
  };
};

const fetchEquipmentModelsFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENT_MODEL_FAIL,
  };
};


export const createServiceFetchEquipmentModels = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchEquipmentModelsStart());
    fetchEquipmentModelsService(page, limit, search, order, orderBy, '')
      .then((res: any) => {
        dispatch(fetchEquipmentModelsSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchEquipmentModelsFail());
      });
  };
};

const fetchGroupsStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_GROUPS_START,
  };
};

const fetchGroupsSuccess = (groups: IEquipmentGroup[] ) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_GROUPS_SUCCESS,
    payload: groups,
  };
};

const fetchGroupsFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_GROUPS_FAIL,
  };
};


export const createServiceFetchGroups = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchGroupsStart());
    fetchGroupsServices(page, limit, search, order, orderBy, '')
      .then((res: any) => {
        dispatch(fetchGroupsSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchGroupsFail());
      });
  };
};

const fetchAreasStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_AREAS_START
  };
};

const fetchAreasSuccess = (areas: IArea[] ) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_AREAS_SUCCESS,
    payload: areas,
  };
};

const fetchAreasFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_AREAS_FAIL,
  };
};


export const createServiceFetchAreas = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchAreasStart());
    fetchAreas(page, limit, search, order, orderBy)
      .then((res: any) => {
        dispatch(fetchAreasSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchAreasFail());
      });
  };
};

const fetchCompaniesStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_COMPANIES_START
  };
};

const fetchCompaniesSuccess = (companies: ICompany[] ) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_COMPANIES_SUCCESS,
    payload: companies,
  };
};

const fetchCompaniesFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_COMPANIES_FAIL,
  };
};


export const createServiceFetchCompanies = (page: number, limit: number, search: string, order: string, orderBy: string) => {
  return (dispatch: any) => {
    dispatch(fetchCompaniesStart());
    fetchCompaniesService(page, limit, search, order, orderBy)
      .then((res: any) => {
        dispatch(fetchCompaniesSuccess(res.data.rows));
      })
      .catch( () => {
        dispatch(fetchCompaniesFail());
      });
  };
};

export const setCreateServiceEquipmentsTableFilters = (equipmentTableFilters: ICreateServiceState['equipmentTableFilters']) => {
  return {
    type: actionTypes.CREATE_SERVICE_SET_EQUIPMENTS_TABLE_FILTERS,
    payload: equipmentTableFilters
  }
}

export const createServiceRemovePlaceFilter = (place: IAutocompleteOption) => {
  return {
    type: actionTypes.CREATE_SERVICE_REMOVE_PLACES_FILTER,
    payload: place,
  }
}

export const createServiceRemoveAreaFilter = (area: IAutocompleteOption) => {
  return {
    type: actionTypes.CREATE_SERVICE_REMOVE_AREAS_FILTER,
    payload: area,
  }
}
export const createServiceRemoveCompanyFilter = (company: IAutocompleteOption) => {
  return {
    type: actionTypes.CREATE_SERVICE_REMOVE_COMPANIES_FILTER,
    payload: company,
  }
}
export const createServiceRemoveGroupFilter = (group: IAutocompleteOption) => {
  return {
    type: actionTypes.CREATE_SERVICE_REMOVE_EQUIPMENT_GROUP_FILTER,
    payload: group,
  }
}
export const createServiceRemoveEquipmentModelFilter = (equipmentModel: IAutocompleteOption) => {
  return {
    type: actionTypes.CREATE_SERVICE_REMOVE_EQUIPMENT_MODEL_FILTER,
    payload: equipmentModel,
  }
}

export const createServiceStatusFilter = (status: ICreateServiceState['equipmentTableFilters']['filteredStatus']) => {
  return {
    type: actionTypes.CREATE_SERVICE_FILTER_STATUS,
    payload: status,
  }
}

export const createServiceClearAllFilters = () => {
  return {
    type: actionTypes.CREATE_SERVICE_CLEAR_ALL_FILTERS,
  }
}

export const fetchEquipmentsStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENTS_START,
  }
}

export const fetchEquipmentsSuccess = (equipments: IEquipment[]) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENTS_SUCCESS,
    payload: equipments,
  }
}

export const fetchEquipmentsFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENTS_FAIL,
  }
}

export const createServiceFetchEquipments = (
  page: number,
  limit: number,
  search: string,
  order: string,
  orderBy: string,
  sites: ISite[],
  filteredPlaces: IAutocompleteOption[],
  filteredModels: IAutocompleteOption[],
  filteredGroups: IAutocompleteOption[],
  filteredAreas: IAutocompleteOption[],
  filteredCompanies: IAutocompleteOption[],
  filteredStatus: ICreateServiceState['equipmentTableFilters']['filteredStatus'],
) => {
  getEquipmentsForCreateService_cancel && getEquipmentsForCreateService_cancel();
  return (dispatch: any) => {
    dispatch(fetchEquipmentsStart());
    fetchEquipmentsService(page, limit, search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, false)
      .then((res: any) => {
        dispatch(fetchEquipmentsSuccess(res.data));
      })
      .catch(() => {
        dispatch(fetchEquipmentsFail());
      });
  };
};

export const fetchQuestionsStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_QUESTIONS_START,
  }
};

export const fetchQuestionsSuccess = (questions: IQuestion[], defaultAnswerNA: boolean) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_QUESTIONS_SUCCESS,
    payload: {
      questions,
      defaultAnswerNA,
    },
  }
};

export const fetchQuestionsFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_QUESTIONS_FAIL,
  }
};

export const createServiceFetchQuestions = (equipmentServiceId: string, siteId: string, defaultAnswerNA: boolean, serviceDraftId: string = '') => {
  return (dispatch: any) => {
    dispatch(fetchQuestionsStart());
    api.get(`/questions/forequipserviceandsite/${equipmentServiceId}/${siteId}`)
      .then((res: any) => {
        dispatch(fetchQuestionsSuccess(res.data, defaultAnswerNA));
        console.log('serviceDraftId', serviceDraftId)
        if (serviceDraftId !== '') {
          dispatch(createServiceLoadDraft(serviceDraftId));
        }
      })
      .catch((e) => {
        console.log(e)
        dispatch(fetchQuestionsFail());
      });
  };
};

const fetchOldActionsStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_GET_OLD_ACTIONS_START,
  }
}

const fetchOldActionsSucess = (actions: IOldAction[]) => {
  return {
    type: actionTypes.CREATE_SERVICE_GET_OLD_ACTIONS_SUCCESS,
    payload: actions,
  }
}

const fetchOldActionsFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_GET_OLD_ACTIONS_FAIL,
  }
}

export const createServicefetchOldActions = (equipmentId: string, equipmentServiceId: string, siteId: string, serviceDate = '', defaultAnswerNA = false, serviceDraftId: string = '') => {
  getServiceFormActions_cancel && getServiceFormActions_cancel();

  return (dispatch: any) => {
    dispatch(fetchOldActionsStart());
    const beforeQuery = serviceDate !== '' ? `?before=${serviceDate}` : '';
    api.get(`/actions/oldactionsfornewservice/${equipmentId}/${equipmentServiceId}${beforeQuery}`, {
      cancelToken: new CancelToken(function executor(c) {
        getServiceFormActions_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchOldActionsSucess(res.data));
        dispatch(createServiceFetchQuestions(equipmentServiceId, siteId, defaultAnswerNA, serviceDraftId));
      })
      .catch(err => {
        console.log(err)
        dispatch(fetchOldActionsFail());
      });
  };
}

export const createServiceChangeServiceDate = (date: Date) => {
  return {
    type: actionTypes.CREATE_SERVICE_CHANGE_SERVICE_DATE,
    payload: date,
  }
}

export const createServiceChangeQuestionAnswer = (answer: string, questionId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_CHANGE_QUESTION_ANSWER,
    payload: {
      answer,
      questionId,
    }
  }
}

export const createServiceChangeQuestionComment = (comment: string, questionId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_CHANGE_QUESTION_COMMENT,
    payload: {
      comment,
      questionId,
    }
  }
}

export const createServiceAddQuestionAction = (action: IAction, questionId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_QUESTION_ACTION,
    payload: {
      action,
      questionId,
    }
  }
}

export const createServiceEditQuestionAction = (action: IAction, questionId: string, actionId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_EDIT_QUESTION_ACTION,
    payload: {
      action,
      questionId,
      actionId,
    }
  }
}

export const createServiceDeleteQuestionAction = (questionId: string, actionId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_DELETE_QUESTION_ACTION,
    payload: {
      questionId,
      actionId,
    }
  }
}

export const createServiceAddQuestionFile = (files: IFile[], questionId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_QUESTION_FILE,
    payload: {
      files,
      questionId,
    }
  }
}

export const createServiceEditQuestionFile = (file: IFile, questionId: string, fileId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_EDIT_QUESTION_FILE,
    payload: {
      file,
      questionId,
      fileId,
    }
  }
}

export const createServiceDeleteQuestionFile = (questionId: string, fileId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_DELETE_QUESTION_FILE,
    payload: {
      questionId,
      fileId,
    }
  }
}

export const createServiceAddObservationFile = (files: IFile[]) => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_FILE,
    payload: {
      files,
    }
  }
}

export const createServiceEditObservationFile = (file: IFile, fileId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_EDIT_FILE,
    payload: {
      file,
      fileId,
    }
  }
}

export const createServiceDeleteObservationFile = (fileId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_DELETE_FILE,
    payload: {
      fileId,
    }
  }
}

const addSignatureStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_SIGNATURE_START
  }
}

const addSignatureSuccess = (signature: ISignature) => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_SIGNATURE_SUCCESS,
    payload: {
      signature
    }
  }
}

const addSignatureSFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_SIGNATURE_FAIL
  }
}

export const createServiceAddSignature = (signature: ISignature | null) => {
  return async (dispatch: any) => {
    dispatch(addSignatureStart());
    try {
      const updateSignature = signature || { canvas: "", signatureId: null };
      const res = await uploadSignature(signature);
      if (res) {
        updateSignature.signatureId = res.id;
        updateSignature.url = res.url;
        updateSignature.source = "web";
      };
      
      dispatch(addSignatureSuccess(updateSignature));
      toastr.success('Assinatura adicionada com sucesso', "")
      return {status:'success', signatureId: updateSignature.signatureId};
    } catch (error) {
      dispatch(addSignatureSFail());
      toastr.error('Falha ao adicionar assinatura', "")
      console.log(error)
    }
  }
}

export const createServiceAddSignatureName = (name: string, index: number) => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_SIGNATURE_NAME,
    payload: {
      name,
      index,
    }
  }
}

export const createServiceAddSignatureComplement = (complement: string, index: number) => {
  return {
    type: actionTypes.CREATE_SERVICE_ADD_SIGNATURE_COMPLEMENT,
    payload: {
      complement,
      index,
    }
  }
}

export const createServiceRemoveSignature = (index: number) => {
  return {
    type: actionTypes.CREATE_SERVICE_REMOVE_SIGNATURE,
    payload: {
      index,
    }
  }
}

export const clearCreateService = (clearDraftId: boolean = false) => {
  return {
    type: actionTypes.CREATE_SERVICE_CLEAR,
    payload: clearDraftId,
  }
}
export const createServiceSelectEquipment = (equipmentId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_SELECT_EQUIPMENT,
    payload: equipmentId,
  }
}

export const fetchEquipmentServicesStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_START,
  }
}

export const fetchEquipmentServicesSuccess = (equipments: IEquipment[]) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_SUCCESS,
    payload: equipments,
  }
}

export const fetchEquipmentServicesFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_EQUIPMENT_SERVICES_FAIL,
  }
}

export const createServiceFetchEquipmentServices = (id: string) => {
  return (dispatch: any) => {
    dispatch(fetchEquipmentServicesStart());
    fetchEquipmentServices(id)
      .then((res: any) => {
        dispatch(fetchEquipmentServicesSuccess(res.data));
      })
      .catch(() => {
        dispatch(fetchEquipmentServicesFail());
      });
  };
};

export const createServiceSelectEquipmentService = (equipmentService: TEquipmentWithServicesEquipmentService) => {
  return {
    type: actionTypes.CREATE_SERVICE_SELECT_EQUIPMENT_SERVICE,
    payload: equipmentService,
  }
}

const createServicePostServiceStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_POST_SERVICE_START,
  }
};

const createServicePostServiceSuccess = () => {
  return {
    type: actionTypes.CREATE_SERVICE_POST_SERVICE_SUCCESS,
  }
};

const createServicePostServiceFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_POST_SERVICE_FAIL,
  }
};

export const createServicePostService = (body: ICreateServiceBody) => {
  return (dispatch: any): Promise<string> => {
    return new Promise((resolve, reject) => {
      dispatch(createServicePostServiceStart());
      api.post('/services', body)
        .then(res => {
          dispatch(createServicePostServiceSuccess());
          toastr.success(i18n.t('postServices.toastr'), '');
          resolve('success');
        })
        .catch(err => {
          dispatch(createServicePostServiceFail());
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const createServiceAnswerAllQuestionsNa = () => {
  return {
    type: actionTypes.CREATE_SERVICE_ANSWER_ALL_QUESTIONS_NA,
  }
}

export const createServiceClearServiceFilesAndSignature = () => {
  return {
    type: actionTypes.CREATE_SERVICE_CLEAR_SERVICE_FILES_SIGNATURE,
  }
}

const refreshOldActionsStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_REFRESH_OLD_ACTIONS_START,
  }
}

const refreshOldActionsSuccess = (actionsId: string[], questionId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_REFRESH_OLD_ACTIONS_SUCCESS,
    payload: {
      actionsId,
      questionId,
    }
  }
}

const refreshOldActionsFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_REFRESH_OLD_ACTIONS_FAIL,
  }
}

export const createServiceRefreshOldActions = (oldActions: IOldAction[], questionId: string) => {
  return (dispatch: any) => {
  dispatch(refreshOldActionsStart());
  api.get(`/actions/refresholdactions?ids=${oldActions.map((oldAction) => oldAction._id).join(',')}`)
    .then(res => {
      dispatch(refreshOldActionsSuccess(res.data, questionId));
    })
    .catch(err => {
      dispatch(refreshOldActionsFail());
    });
  }
}

const createServiceDraftStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_DRAFT_START,
  }
}

const createServiceDraftSuccess = (payload: {serviceDraftId: string, serviceDraft: IServiceDraft}) => {
  return {
    type: actionTypes.CREATE_SERVICE_DRAFT_SUCCESS,
    payload,
  }
}

const createServiceDraftFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_DRAFT_FAIL,
  }
}

export const createServiceDraft = (body: ICreateServiceBody) => {
    createDraft_cancel && createDraft_cancel();
  return (dispatch: any) => {
    dispatch(createServiceDraftStart());
    api.post('/servicedrafts/create', body, {
      cancelToken: new CancelToken(function executor(c) {
        createDraft_cancel = c;
      })
    })
      .then((res)=> {
        dispatch(createServiceDraftSuccess({serviceDraftId: res.data.serviceId, serviceDraft: res.data.serviceDraft}));
      })
      .catch(err => {
        console.log(err);
        dispatch(createServiceDraftFail());
      });
  }
}


const updateServiceDraftStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_UPDATE_DRAFT_START,
  }
}

const updateServiceDraftSuccess = (serviceDraft: IServiceDraft) => {
  return {
    type: actionTypes.CREATE_SERVICE_UPDATE_DRAFT_SUCCESS,
    payload: serviceDraft,
  }
}

const updateServiceDraftFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_UPDATE_DRAFT_FAIL,
  }
}

export const updateServiceDraft = (serviceId: string, body: IUpdateServiceDraftBody) => {
  return (dispatch: any) => {
    dispatch(updateServiceDraftStart());
    api.put(`/servicedrafts/update/${serviceId}`, body)
      .then((res) => {
        dispatch(updateServiceDraftSuccess(res.data.serviceDraft));
      })
      .catch(err => {
        dispatch(updateServiceDraftFail());
      });
  }
}

const fetchServiceDraftsStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_SERVICE_DRAFTS_START,
  }
}

const fetchServiceDraftsSuccess = (drafts: {rows: IServiceDraft[], count: number}) => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_SERVICE_DRAFTS_SUCCESS,
    payload: drafts,
  }
}

const fetchServiceDraftsFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_FETCH_SERVICE_DRAFTS_FAIL,
  }
}

export const createServicefetchServiceDrafts = (page: number, limit: number, equipmentId: string, equipmentServiceId: string) => {
  let query = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&sort=-createdAt`;
  query += `&equipment=${equipmentId}`;
  query += `&equipmentService=${equipmentServiceId}`;

  return (dispatch: any) => {
    dispatch(fetchServiceDraftsStart());
    api.get('/servicedrafts' + query)
      .then((res)=> {
        dispatch(fetchServiceDraftsSuccess(res.data.data));
      })
      .catch(err => {
        dispatch(fetchServiceDraftsFail());
      });
  }
}

const loadDraftStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_LOAD_DRAFT_START,
  }
}

const loadDraftSuccess = (draft: IServiceDraft) => {
  return {
    type: actionTypes.CREATE_SERVICE_LOAD_DRAFT_SUCCESS,
    payload: draft,
  }
}

const loadDraftFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_LOAD_DRAFT_FAIL,
  }
}

export const createServiceLoadDraft = (draftId: string) => {
  return (dispatch: any) => {
    dispatch(loadDraftStart());
    api.get(`/servicedrafts/${draftId}`)
      .then((res)=> {
        dispatch(loadDraftSuccess(res.data.data));
      })
      .catch(err => {
        dispatch(loadDraftFail());
      });
  }
}


const deleteDraftStart = (draftId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_DELETE_DRAFT_START,
    payload: draftId
  }
}

const deleteDraftSuccess = () => {
  return {
    type: actionTypes.CREATE_SERVICE_DELETE_DRAFT_SUCCESS,
  }
}

const deleteDraftFail = () => {
  return {
    type: actionTypes.CREATE_SERVICE_DELETE_DRAFT_FAIL,
  }
}

export const createServiceDeleteDraft = (draftId: string, page: number, limit: number, equipmentServiceId: string, equipmentId: string) => {
  return (dispatch: any) => {
    dispatch(deleteDraftStart(draftId));
    api.put(`/servicedrafts/${draftId}/delete`)
      .then((res)=> {
        dispatch(deleteDraftSuccess());
        toastr.success(i18n.t('createService.toastrSucessDeleteDraftTitle'), '')
        dispatch(createServicefetchServiceDrafts(page, limit, equipmentId, equipmentServiceId));
      })
      .catch(err => {
        dispatch(deleteDraftFail());
        toastr.error('createService.toastrErrorDeleteDraftTitle', err.message);
      });
  }
}

export const createServiceSetServiceDraftId = (draftId: string) => {
  return {
    type: actionTypes.CREATE_SERVICE_SET_SERVICE_DRAFT_ID,
    payload: draftId
  }
}
